function bsTooltip(el, binding) {
    $(el).tooltip({
        title: binding.value
    });
}

export default {
    bind: bsTooltip,
    update: bsTooltip,
    unbind(el, binding) {
        $(el).tooltip('dispose');
    }
};